module.exports = __webpack_public_path__ + "static/media/How to create a Branch.052a3371.png";